import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  EstimatorApiResponse,
  EstimatorResponse,
  EmbeddedUserReportsApiResponse,
  EmbeddedUserReportsData,
  createEmbeddedEstimator,
  getEmbeddedUserReports,
} from "./estimatorAction";

interface EstimatorState {
  estimator: EstimatorResponse | null;
  reports: EmbeddedUserReportsData | null;
  loading: boolean;
  error: string | null;
}

const initialState: EstimatorState = {
  estimator: null,
  reports: null,
  loading: false,
  error: null,
};

const estimatorSlice = createSlice({
  name: "estimator",
  initialState,
  reducers: {
    resetEstimatorState: (state) => {
      state.estimator = null;
      state.reports = null;
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle createEmbeddedEstimator
      .addCase(createEmbeddedEstimator.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        createEmbeddedEstimator.fulfilled,
        (state, action: PayloadAction<EstimatorApiResponse>) => {
          state.loading = false;
          state.estimator = action.payload.data?.estimator || null;
          state.error = null;
        }
      )
      .addCase(
        createEmbeddedEstimator.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.loading = false;
          state.error = action.payload || "Failed to create estimator report";
        }
      )
      // Handle getEmbeddedUserReports
      .addCase(getEmbeddedUserReports.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        getEmbeddedUserReports.fulfilled,
        (state, action: PayloadAction<EmbeddedUserReportsApiResponse>) => {
          state.loading = false;
          state.reports = action.payload.data || null;
          state.error = null;
        }
      )
      .addCase(
        getEmbeddedUserReports.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.loading = false;
          state.error =
            action.payload || "Failed to fetch embedded user reports";
        }
      );
  },
});

export const { resetEstimatorState } = estimatorSlice.actions;
export default estimatorSlice.reducer;
